import React, { useState, useEffect } from 'react';
import { isAuthenticated } from '../../store/action/auth';
import axios from "axios";
import { API } from "../../config";
import {Image} from "react-bootstrap";

const AdminUser = (props) => {
    const { token } = isAuthenticated();
    const [ sku, setSku ] = useState("");
    const [ initStock, setInitStock ] = useState(0);
    const [ stock , setStock ] = useState(0);
    const [ product, setProduct ] = useState({});

    useEffect(async () => {
        const { sku } = props.match.params;
        setSku(sku);
        await onCheckCurrentStock(sku)
    },[]);

    const onCheckCurrentStock = async (sku) => {
        try {
            const res = await axios.get(`${API}/v1/admin/inventories/sku/${sku}`, {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`
                }
            });
            if(res.data.success) {
                setInitStock(res.data.stock);
                setStock(res.data.stock);
                setProduct(res.data.product)
            } else {
                alert(res.data.error);
            }
        } catch (e) {
            alert(e.response.data.error)
        }
    };

    const onAddStock = async () => {
        try {
            const res = await axios.post(`${API}/v1/stock_movements/sku`, {sku}, {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`
                }
            });
            if(res.data.success) {
                setStock(res.data.stock);
            } else {
                alert(res.data.error);
            }
        } catch (e) {
            alert(e.response.data.error)
        }
    };

    const onRemoveStock = async () => {
        try {
            const res = await axios.post(`${API}/v1/stock_movements/sku/${sku}`, {}, {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`
                }
            });
            if(res.data.success) {
                setStock(res.data.stock);
            } else {
                alert(res.data.error);
            }
        } catch (e) {
            alert(e.response.data.error)
        }
    };

    const onRestoreStock = async () => {
        try {
            const res = await axios.post(`${API}/v1/stock_movements/sku/${sku}/restore`, {}, {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`
                }
            });
            if(res.data.success) {
                setStock(res.data.stock);
            } else {
                alert(res.data.error);
            }
        } catch (e) {
            alert(e.response.data.error)
        }
    };

    return (
        <div className="bg-white rounded shadow">
            <div className="p-4 justify-content-between d-flex">
                <h5>Update Stok Barang</h5>
            </div>
            <div className="px-3 pb-4 row text-center">
                <div className="col-12">
                    <h2>
                        {product.name}
                    </h2>
                    <h5>
                        {product.details}
                    </h5>
                </div>
                <div className="col-8 center">
                    <Image rounded alt="Product Image" src={product.image}
                           className="img-fluid img-center"/>
                </div>
            </div>
            <div className="px-3 pb-4 row text-center">
                <div className="col-6">
                    <h6>Stok Mula</h6>
                    <h1>{initStock}</h1>
                </div>
                <div className="col-6">
                    <h6>Stok Sebenarnya</h6>
                    <h1>{stock}</h1>
                </div>
            </div>
            <div className="px-3 pb-4 form-row justify-content-center align-items-center">
                <div className="col-8">
                    <input
                        type="text"
                        onChange={e => setSku(e.target.value.toUpperCase())}
                        placeholder="Masukkan SKU Barang"
                        className="form-control "
                        value={sku}
                        required
                    />
                </div>
                <div className="col-4">
                    <button
                        className="btn btn-light mr-3 btn-block"
                        onClick={() => onCheckCurrentStock(sku)}
                    >
                        Cek Stok
                    </button>
                </div>
            </div>
            <div className="px-3 pb-4 form-row justify-content-center align-items-center">
                <div className="col-6">
                    <button
                        className="btn btn-primary mr-3 btn-block"
                        onClick={onAddStock}
                    >
                        Tambah
                    </button>
                </div>
                <div className="col-6">
                    <button
                        className="btn btn-primary mr-3 btn-block"
                        onClick={onRemoveStock}
                    >
                        Kurang
                    </button>
                </div>
            </div>
            <div className="px-3 pb-4 row justify-content-center align-items-center">
                <div className="col-6">
                    <button
                        className="btn btn-danger mr-3 btn-block"
                        onClick={onRestoreStock}
                    >
                        Restore
                    </button>
                </div>
            </div>
        </div>
    )
};


export default AdminUser;
